import { render, staticRenderFns } from "./DataListAssignation.vue?vue&type=template&id=7a35f7f2&"
import script from "./DataListAssignation.vue?vue&type=script&lang=js&"
export * from "./DataListAssignation.vue?vue&type=script&lang=js&"
import style0 from "./DataListAssignation.vue?vue&type=style&index=0&id=7a35f7f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports